

window.addEventListener('load', () => {


    // Закрытие при клике на overlay
    document.querySelectorAll('.notification-modal-overlay').forEach(overlay => {
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                overlay.classList.remove('active');
            }
        });
    });

    // Закрытие по клавише Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            document.querySelectorAll('.notification-modal-overlay').forEach(overlay => {
                overlay.classList.remove('active');
            });
        }
    });


    document.querySelectorAll('[data-notification-modal-close]').forEach(button => {
        button.addEventListener('click', () => {
           document.getElementById('successModal').classList.remove('active');
           document.getElementById('errorModal').classList.remove('active');
        });
    });


});

    // Функции для работы с модальными окнами
  window.showNotificationModal =  function showNotificationModal(modalId, content =  '') {

       $modal = document.getElementById(modalId).classList.add('active');

         if (content) {
            document.getElementById(modalId).querySelector('.notification-modal-text').innerHTML = content.replace(/!/g, "!<br>");
        }

    }
